const AUDIOEYE_SCRIPT_ID = 'audioeye-site-code';

class AudioEyeDomService {
  private scriptRegistered: boolean = false;

  public addWidgetScript(siteHash: string): void {
    if (this.scriptRegistered || document.getElementById(AUDIOEYE_SCRIPT_ID)) {
      return;
    }

    this.scriptRegistered = true;

    const appendScript = (): void => {
      // eslint-disable-next-line no-underscore-dangle
      (<any>window).__AudioEyeSiteHash = siteHash;

      const script = document.createElement('script');
      script.id = AUDIOEYE_SCRIPT_ID;
      script.src = `https://wsv3cdn.audioeye-services.com/aem.js?h=${siteHash}`;
      script.type = 'text/javascript';
      script.crossOrigin = 'anonymous';
      script.async = true;
      document.body.appendChild(script);
    };

    if (document.readyState === 'complete') {
      appendScript();
    } else {
      window.addEventListener('load', appendScript, { once: true });
    }
  }
}

export const audioEyeDomService = new AudioEyeDomService();
